/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_heat_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gene,S1,S2,S3
GeneA,12,45,30
GeneB,50,22,15`)
};

const es_heat_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gen,M1,M2,M3
GenA,12,45,30
GenB,50,22,15`)
};

const de_heat_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gene,S1,S2,S3
GeneA,12,45,30
GeneB,50,22,15`)
};

const nl_heat_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gen,S1,S2,S3
GenA,12,45,30
GenB,50,22,15`)
};

const fr_heat_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gène,S1,S2,S3
GèneA,12,45,30
GèneB,50,22,15`)
};

const it_heat_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gene,S1,S2,S3
GeneA,12,45,30
GeneB,50,22,15`)
};

const pt_br2_heat_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gene,A1,A2,A3
GeneA,12,45,30
GeneB,50,22,15`)
};

const pt_heat_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gene,S1,S2,S3
GeneA,12,45,30
GeneB,50,22,15`)
};

const ja_heat_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gene,S1,S2,S3
GeneA,12,45,30
GeneB,50,22,15`)
};

const zh_heat_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gene,S1,S2,S3
GeneA,12,45,30
GeneB,50,22,15`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const heat_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.heat_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("heat_placeholder", locale)
	if (locale === "en") return en_heat_placeholder(inputs)
	if (locale === "es") return es_heat_placeholder(inputs)
	if (locale === "de") return de_heat_placeholder(inputs)
	if (locale === "nl") return nl_heat_placeholder(inputs)
	if (locale === "fr") return fr_heat_placeholder(inputs)
	if (locale === "it") return it_heat_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_heat_placeholder(inputs)
	if (locale === "pt") return pt_heat_placeholder(inputs)
	if (locale === "ja") return ja_heat_placeholder(inputs)
	return zh_heat_placeholder(inputs)
};